import { render, staticRenderFns } from "./SubscriptionConfirm.vue?vue&type=template&id=5432524e&scoped=true"
import script from "./SubscriptionConfirm.vue?vue&type=script&lang=ts"
export * from "./SubscriptionConfirm.vue?vue&type=script&lang=ts"
import style0 from "./SubscriptionConfirm.vue?vue&type=style&index=0&id=5432524e&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5432524e",
  null
  
)

export default component.exports